// src/components/admin/RegionsList.js
import React from 'react';
import RefDictionaryPage from './RefDictionaryPage';

export default function RegionsList() {
  return (
    <RefDictionaryPage
      breadcrumbs="Справочники"
      title="Регионы"
      subtitle="Города, в которых работает CRM"
      endpoint="v1/regions"
      searchKeys={['name']}
      columns={[
        { key: 'id', label: 'ID', width: 80 },
        { key: 'name', label: 'Название' },
      ]}
      fields={[
        { key: 'name', label: 'Название региона', required: true, placeholder: 'Алматы' },
      ]}
      emptyRecord={{ name: '' }}
    />
  );
}
